module.exports = __webpack_public_path__ + "src/assets/games/43/372.jpg";